import { motion } from 'framer-motion';
import { SuccessIcon } from './icons/SuccessIcon';
import { WarningIcon } from './icons/WarningIcon';
import { ErrorIcon } from './icons/ErrorIcon';

type ToastVariant = 'success' | 'warning' | 'error';

interface ToastProps {
  message: string;
  variant: ToastVariant;
}

const variantConfig = {
  success: {
    containerClasses: 'bg-[#EAFEED] border border-[#26E645]',
    textClasses: 'text-[#04430E]',
    Icon: SuccessIcon,
  },
  warning: {
    containerClasses: 'bg-[#FFF9F0] border border-[#FFDA9E]',
    textClasses: 'text-[#001A4C]',
    Icon: WarningIcon,
  },
  error: {
    containerClasses: 'bg-[rgba(254,236,230,0.75)] border border-[#FDC4B2]',
    textClasses: 'text-[#681B03]',
    Icon: ErrorIcon,
  },
};

export const Toast = ({ message, variant }: ToastProps) => {
  const { containerClasses, textClasses, Icon } = variantConfig[variant];

  return (
    <motion.div
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -20, opacity: 0 }}
      transition={{ duration: 0.2, ease: [0.215, 0.61, 0.355, 1] }}
      className="fixed top-4 left-3 right-3 flex justify-center z-50"
    >
      <div
        className={`w-full max-w-md backdrop-blur-xl rounded-2xl p-4 h-14 flex items-center gap-3 ${containerClasses}`}
      >
        <Icon />
        <span className={`font-geist font-medium text-sm ${textClasses}`}>
          {message}
        </span>
      </div>
    </motion.div>
  );
};
